import React, { createContext, useContext } from "react";

export interface UploadI18nMessages {
  [key: string]: string;
}

export interface UploadI18nContextValue {
  lang: string;
  messages: UploadI18nMessages;
  rtl: boolean;
}

const UploadI18nContext = createContext<UploadI18nContextValue>({
  lang: "pt",
  messages: {},
  rtl: false,
});

export const useUploadI18n = () => useContext(UploadI18nContext);

interface UploadI18nProviderProps {
  i18n: Record<string, UploadI18nMessages>;
  lang: string;
  children: React.ReactNode;
}

const RTL_LANGS = ["ar", "he", "fa", "ur"];

export const UploadI18nProvider: React.FC<UploadI18nProviderProps> = ({
  i18n,
  lang,
  children,
}) => {
  const messages = i18n[lang] || i18n["pt"] || {};
  const rtl = RTL_LANGS.includes(lang);
  return (
    <UploadI18nContext.Provider value={{ lang, messages, rtl }}>
      {children}
    </UploadI18nContext.Provider>
  );
};